import handleFuncObj from "./function.js";

let filter = {
    install(Vue) {
        let filters = Vue.options.filters
        for (const key in handleFuncObj) {
            if (key in filters) {
                console.error("已经被注册过");
            } else {
                Vue.filter(key, handleFuncObj[key])
            }
        }
    }
}

export default filter